import { useEffect, useState } from "react";
import { useContext } from "react";
import { getMediaEntitlement } from "@coxauto-ui/cxm/communications/api";
import { ConversationContext } from "../../context";

export interface UseMediaEntitlementResult {
  isMediaEntitled: boolean;
}

// Module-level cache so entitlement survives unmount/remount across channel switches
let entitledOrgCache: string | null = null;

export function useMediaEntitlement(enabled = true): UseMediaEntitlementResult {
  const { commonOrgId } = useContext(ConversationContext);
  const [isMediaEntitled, setIsMediaEntitled] = useState(
    enabled && entitledOrgCache === commonOrgId
  );

  useEffect(() => {
    if (!enabled || !commonOrgId) return;
    if (entitledOrgCache === commonOrgId) return;

    getMediaEntitlement(commonOrgId)
      .then(entitled => {
        setIsMediaEntitled(entitled);
        if (entitled) {
          entitledOrgCache = commonOrgId;
        }
      })
      .catch(() => {
        // fail-closed: non-entitled dealers don't see the UI
      });
  }, [enabled, commonOrgId]);

  return { isMediaEntitled: enabled && isMediaEntitled };
}

// Exported for testing only
export function _resetEntitlementCache() {
  entitledOrgCache = null;
}
